import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "col-lg-4" }
const _hoisted_2 = { class: "btn btn-outline btn-outline-dashed btn-outline-default p-7 d-flex align-items-center" }
const _hoisted_3 = /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-3x me-5" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-desktop" })
], -1)
const _hoisted_4 = { class: "d-block fw-bold text-start" }
const _hoisted_5 = { class: "settings-heading fw-bolder d-block fs-4 mb-2" }
const _hoisted_6 = { class: "fw-bold fs-6 settings-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_router_link, { to: "/system/settings/home-screens" }, {
      default: _withCtx(() => [
        _createVNode("label", _hoisted_2, [
          _hoisted_3,
          _createVNode("span", _hoisted_4, [
            _createVNode("span", _hoisted_5, _toDisplayString(_ctx.$t("message.HOME_CONTROLLER")), 1),
            _createVNode("span", _hoisted_6, _toDisplayString(_ctx.$t("message.CLICK_TO_MANAGE_HOME_SCREENS")), 1)
          ])
        ])
      ]),
      _: 1
    })
  ]))
}